import type {
  ConsoleMessageResponse,
  ConsolePlanApi,
  ConsolePlanFeatureCatalogResponse,
  ConsoleSubscriptionListRow,
  ConsoleSubscriptionPaymentApi,
  ConsoleSubscriptionPaymentCreateResponse,
  ConsoleTenantDetail,
  ConsoleTenantPlanAssignResponse,
} from "@redipos/contracts";
import { http } from "../../shared/http.js";

/** Pedido de un cliente desde "Mi suscripción" (cambio de plan o aviso de pago). */
export interface SubscriptionRequestRow {
  id: string;
  tenantId: string;
  tenantName: string | null;
  type: "plan_change" | "payment_notice" | string;
  status: "pending" | "resolved" | "rejected" | string;
  requestedBy: string | null;
  planId: string | null;
  planName: string | null;
  fromPlanName: string | null;
  amount: string | null;
  method: string | null;
  reference: string | null;
  note: string | null;
  resolvedAt: string | null;
  resolutionNote: string | null;
  createdAt: string;
}

export const finanzasApi = {
  planFeatureCatalog: () => http.get<ConsolePlanFeatureCatalogResponse>("/admin/finanzas/meta/plan-features"),
  plans: () => http.get<ConsolePlanApi[]>("/admin/finanzas/plans"),
  createPlan: (body: unknown) => http.post<ConsolePlanApi>("/admin/finanzas/plans", body),
  updatePlan: (id: string, body: unknown) =>
    http.put<ConsolePlanApi>(`/admin/finanzas/plans/${encodeURIComponent(id)}`, body),
  deletePlan: (id: string) =>
    http.delete<ConsoleMessageResponse>(`/admin/finanzas/plans/${encodeURIComponent(id)}`),

  subscriptions: () => http.get<ConsoleSubscriptionListRow[]>("/admin/finanzas/subscriptions"),

  /** Ficha de billing de un tenant (mismo tenant que ve Operaciones, recorte financiero). */
  tenant: (id: string) => http.get<ConsoleTenantDetail>(`/admin/finanzas/tenants/${encodeURIComponent(id)}`),
  updateTenantPlan: (id: string, body: unknown) =>
    http.put<ConsoleTenantPlanAssignResponse>(`/admin/finanzas/tenants/${encodeURIComponent(id)}/plan`, body),
  tenantPayments: (tenantId: string) =>
    http.get<ConsoleSubscriptionPaymentApi[]>(`/admin/finanzas/tenants/${encodeURIComponent(tenantId)}/payments`),
  createPayment: (tenantId: string, body: unknown) =>
    http.post<ConsoleSubscriptionPaymentCreateResponse>(
      `/admin/finanzas/tenants/${encodeURIComponent(tenantId)}/payments`,
      body,
    ),

  requests: (status: "pending" | "all" = "pending") =>
    http.get<SubscriptionRequestRow[]>(`/admin/finanzas/requests?status=${status}`),
  requestsCount: () => http.get<{ pending: number }>("/admin/finanzas/requests/count"),
  applyPlanRequest: (id: string, body: { status?: string; note?: string } = {}) =>
    http.post<SubscriptionRequestRow>(`/admin/finanzas/requests/${encodeURIComponent(id)}/apply-plan`, body),
  closeRequest: (id: string, body: { outcome: "resolved" | "rejected"; note?: string }) =>
    http.post<SubscriptionRequestRow>(`/admin/finanzas/requests/${encodeURIComponent(id)}/close`, body),
};
